export default __webpack_public_path__ + "precision_m647f7c.png";